import React from "react";

import { Toolbar, ToolbarGroup } from "../Toolbar";
import { Button } from "@blueprintjs/core";
import { FilterToolbar } from "../FilterToolbar";

function OrderPageHeader({
  filters,
  filterOptions,
  setFilters = () => {},
  onExportPress = () => {},
  isExportLoading
}) {
  return (
    <Toolbar title="Order Management">
      <FilterToolbar
        value={filters}
        onChange={setFilters}
        filterOptions={filterOptions}
      />

      <ToolbarGroup>
        <Button
          icon="share"
          className="narrow bold"
          text="CSV Export"
          onClick={onExportPress}
          loading={isExportLoading}
        />
      </ToolbarGroup>
    </Toolbar>
  );
}

export default OrderPageHeader;
